//package imports
import React,{useEffect,useState} from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";


//component imports
import osanLogo from "../../assests/images/osanLogo1.webp"
import osanLogin from "../../assests/images/loginChange1.webp"
import { showToast } from "../../utils/constants/Toaster";
import CustomButton from "../../utils/resuableComponents/CustomButton";
import CustomTextField from "../../utils/resuableComponents/CustomTextfield";
import { LoginApi } from "../../services/apiServices/PostServices";
import { validEmail,EmailOrLoginText,ValidMobileNumberText,ValidEmailIdText,TextLoginEmailOtp} from "../../utils/TextInputUtils";

 const Login = (props) => {
  const { path } = useRouteMatch();
  const { location } = props;

  const history = useHistory();
  const propMobileNumber = props?.location?.state?.mobile_number
  const PropsEmail = props?.location?.state?.email
  const [mobileNumber, setMobileNumber] = useState("")
  const [emailId,setEmailId]=useState("")
  const [disableButton, setDisableButton] = useState(true)

  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors },
} = useForm({
    defaultValues: {
        checkbox: false,
    },
});

useEffect(() => {
  if(propMobileNumber !== undefined || PropsEmail !== undefined){
    setMobileNumber(propMobileNumber)
    setEmailId(PropsEmail)
  }
}, []);


  useEffect(() => {
      if ((mobileNumber != "" && mobileNumber.length >= 10) || emailId !== "") {
          setDisableButton(false)
      } else {
          setDisableButton(true)
      }
  }, [mobileNumber,emailId]);

  const handleInputChange = (e) => {
    let value = e;
     // Remove leading zeros
      value = value.replace(/^0+/, '');

     // Allow only numeric characters
      value = value.replace(/\D/g, '');

     setMobileNumber(value)
  };

  const handleEmailChange = (e) => {
    let value = e;
     // Remove leading zeros
     // Allow only numeric characters
      // value = value.replace(/\D/g, '');

      setEmailId(value)
  };


  const handleLogin = async () => {
      const emailPattern = validEmail;

      if (mobileNumber === "" && emailId === "") {
        showToast(3, EmailOrLoginText);
      } else if (mobileNumber !== "" && mobileNumber.length < 10) {
        showToast(3, ValidMobileNumberText);
      } else if (emailId !== "" && !emailPattern.test(emailId)) {
        showToast(3, ValidEmailIdText);
      } else {

        const reqbody = {
          phone_number: mobileNumber,
          email:emailId
        };
        try {
          const res = await LoginApi("login", reqbody);
          if (res?.success) {
            history.push({
              pathname: "/otpVerification",
              state: {
                mobile_number: mobileNumber,
                email:emailId
              },
            });
            setDisableButton(true)
          } else {
            showToast(3, res?.message);
          }
        } catch (error) {
          console.log(error);
        }
      }
  }

  return (
    <div class="container-fluid p-0">
        <div class="col-md-12 d-flex flex-row ">
          <div class="col-md-1">
          </div>
        <div class="full-container d-flex col-md-5 pl-4 ">
          <div class="d-flex justify-content-end mt-4  ">
          <img src={osanLogin} class="img-fluid mx-4 mt-4" alt="osanLoginImg" />
          </div>
        </div>
      <div class="d-flex flex-column col-md-5  justify-content-center align-items-center ">
        <div class="d-flex flex-column col-md-10 align-self-end  ">
        <div class="text-center ">
                <img src={osanLogo} class="img-fluid    my-1  " alt="Osan_logo" />
            </div>
        </div>
        <div class="d-flex flex-column col-md-10  align-self-end">
            <div class="d-flex flex-column align-items-center mx-4">
                <h1 >Log In</h1>
                <p class="text-justify">{TextLoginEmailOtp}</p>  
            </div>
            <div class="mb-2 mx-4 ">
                <CustomTextField
                    control={control}
                    header={"Mobile Number"}
                    name="number"
                    size="small"
                    value={mobileNumber.trimStart()}
                    placeholder={"Mobile Number"}
                    inputProps={{
                        min: 10,
                        maxLength: 10
                    }}
                    onChange={(e) => {
                        const result = e.replace(/\D/g, "");
                        handleInputChange(e);
                    }}
                />
            </div>
            <div>
              <h6 className="text-justify text-center m-0">{"(or)"}</h6>
            </div>

            <div class="mb-3 mx-4 ">
                <CustomTextField
                    control={control}
                    header={"Email Id"}
                    name="Email Id"
                    size="small"
                    value={emailId.trimStart()}
                    placeholder={"Email Id"}
                    inputProps={{
                        min: 3,
                    }}
                    onChange={(e) => {
                        const result = e.replace(/\D/g, "");
                        handleEmailChange(e);
                    }}
                />
            </div>
        
            <div class="mx-4 align-self-center">
                <CustomButton
                    children={"Get OTP"}
                    onClick={handleLogin}
                    disabled={disableButton}
                />
            </div>
        </div>
      </div>
      <div class="col-md-1">
          </div>
        </div>
      </div>
  );
};


export default Login